import http, { expandURI } from '@/utils/ajax'
import { CREDITNOTE_INIT_LOADING, CREDITNOTE_INIT_SUCCESS, CREDITNOTE_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async creditNoteInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.creditNote
    const expand = {}
    if (apiUrl) {
      commit(CREDITNOTE_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(CREDITNOTE_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(CREDITNOTE_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CREDITNOTE_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
